module.exports = __webpack_public_path__ + "media/images/icon_member-56eeb647.png";